export default "__VITE_ASSET__8619724c__"